export default {
  grayHeader: '利用規約',
  terms: [
    {
      title: '第1条（適用範囲）',
      detail:
        '　星野リゾート宿泊ギフト券お客様利用規約（以下「本規約」といいます）は、株式会社ドキドキ旅行（以下「当社」といいます）が発行する星野リゾート宿泊ギフト券に関する取扱いについて定めるものです。お客様は、本規約の内容を十分に理解し、本規約にご同意いただいた上で、星野リゾート宿泊ギフト券を購入し、ご利用いただくものとします。'
    },
    {
      title: '第2条（星野リゾート宿泊ギフト券について）',
      detail:
        '　星野リゾート宿泊ギフト券（以下「本券」といいます）は、当社が、券面に記載された金額に応ずる対価を得て発行する前払式支払手段（資金決済に関する法律第３条第１項第１号）である商品券（紙）をいいます。\n　星野リゾート宿泊ギフト券の券面には、星野リゾートのサービスマークと金額が明記されており、券種は五万円券の1種類とします。'
    },
    {
      title: '第3条（利用範囲及び利用対象施設）',
      detail:
        '　本券は、「星野リゾート」のロゴを表示した利用対象施設における、ご宿泊料金、ご滞在中のお食事代及びその他のお部屋付けされた館内利用料金の代金決済にご利用いただけます。\n　利用対象施設は、星野リゾート公式ホームページ上の「宿泊ギフト券」の欄から閲覧できる当社WEBサイト上で表示される施設といたします。'
    },
    {
      title: '第4条（本券の発行）',
      detail: '　本券は、当社WEBサイト上において、購入することができます。'
    },
    {
      title: '第5条（本券のご利用）',
      detail:
        '　お客様は、第3条に規定する利用対象施設における、ご宿泊料金、ご滞在中のお食事代及びその他のお部屋付けされた館内利用料金の代金決済にご利用いただけます。（自動販売機での購入など、お部屋付けができないお支払いは対象となりませんのでご注意ください。）\n　利用にあたっては必ず星野リゾート公式ホームページ上からのWEB予約または星野リゾート予約センターでの電話予約等による事前申請が必要となり、万が一、事前申請なしに本券をお持ちいただいた場合には、代金決済にご利用いただけないため、予めご注意願います。その他の宿泊予約サイト及び旅行会社経由のご予約の場合においては代金決済にご利用いただけません。\n　また、利用にあたっては、必ず本券を宿泊いただく利用対象施設へご持参いただき、館内にてスタッフにご提出願います。'
    },
    {
      title: '第6条（本券の払戻し等）',
      detail:
        '　お客様は、本券について、払戻しまたは換金することはできません。\n　また、ご宿泊及びお部屋付けされた館内利用金額が本券の券面額に満たなかった場合でも現金その他による差額の返金はできません。\n　ただし、当社が経済情勢の変化、法令の改廃その他当社の都合により本券の取扱いを全面的に廃止した場合には、法令の定めに従い、お客様に対して当社所定の方法により、本券の券面額に相当する金額を払戻しいたします。'
    },
    {
      title: '第7条（有効期間）',
      detail:
        '　本券の有効期間は購入時に購入者により当社WEBサイト上で指定された開始日（有効期間の開始日は、購入日から2ヶ月先までの日程内で指定可能）から1年間とします。有効期間を経過した本券は失効し、ご利用ができなくなりますのでご留意ください。この場合、本券の券面額に相当する金額は、返金しないものとします。\n　なお、有効期間については、本券の表面に記載されております。'
    },
    {
      title: '第8条（ご利用の中止または中断）',
      detail:
        '　当社は、本券のご利用の中止または中断の必要があると認めた時は、お客様に事前に通知することなく、本券のご利用の中止または中断することができるものとします。'
    },
    {
      title: '第9条（本規約の変更または廃止等）',
      detail:
        '　本規約およびご利用いただける利用対象施設の範囲は、経済情勢の変化、法令の改廃その他当社の都合により、変更または廃止することがあります。また、かかる変更または廃止のために、本券の全部または一部の利用を停止することがあります。\n　本規約を変更または廃止したときは、当社WEBサイト上における掲示により告知します。'
    },
    {
      title: '第10条（転売等の禁止）',
      detail:
        '　本券をインターネット上の売買／転売サイト・オークションサイトに出品、または金券を扱う古物商（いわゆる金券ショップ）に売却することは禁止とさせていただきます。 '
    },
    {
      title: '第11条（本券の使用に係る苦情等の連絡体制）',
      detail:
        '　加盟店における本券の使用に係る苦情等については、下記のお客様ご相談窓口にて対応いたします。\n\n【本券に関するお客様ご相談窓口】\n星野リゾート予約センター：050-3134-8094'
    },
    {
      title: '第12条（管轄）',
      detail:
        '　本規約に基づく取引に関して訴訟の必要が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。'
    }
  ],
  endOfTerms: {
    publisher: '発行者：株式会社ドキドキ旅行',
    contactHeader: '【本券に関するお客様ご相談窓口】',
    contact: '星野リゾート予約センター：050-3134-8094',
    dateOfEnforcement: '2017年12月1日から施行',
    end: '以　上'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/terms.js